// extracted by mini-css-extract-plugin
export default {"drawer-item":"LeftMenuItemDrawer_drawer-item__pT+et","drawer-item-selected":"LeftMenuItemDrawer_drawer-item-selected__+JX4X"};